import projection from '../generated/pwc5n6f1.json';
import { AcceptanceManifest } from '../types';

export const pwc5n6f1AcceptanceManifest = projection as AcceptanceManifest;
